import classnames from "classnames";
import type { ReactNode } from "react";

import { Icon, IconNames } from "@/components/icon/icon";

import styles from "./item-card-content.module.css";

export interface ItemCardStatus {
  text: string;
  icon?: IconNames;
}

interface ItemCardContentProps {
  title: string;
  subtitle?: ReactNode;
  status?: ItemCardStatus;
  className?: string;
}

export function ItemCardContent({
  title,
  subtitle,
  status,
  className,
}: ItemCardContentProps) {
  return (
    <div className={classnames(styles.card, className)} data-item-card>
      <div className={styles.cardContent}>
        <div className={styles.cardMain}>
          <div>{title}</div>
          {subtitle != null && <div className={styles.content}>{subtitle}</div>}
        </div>
        {status && (
          <div className={styles.statusLabel}>
            {status.icon && <Icon name={status.icon} size={16} />}
            <span>{status.text}</span>
          </div>
        )}
      </div>
    </div>
  );
}
